enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

interface ILoggerInfoType {
  color: string;
  levelCode: number;
}

interface ILoggerInfo {
  debug: ILoggerInfoType;
  info: ILoggerInfoType;
  warn: ILoggerInfoType;
  error: ILoggerInfoType;
}

interface IConsoleLogger {
  debug: (...data: any) => void;
  info: (...data: any) => void;
  warn: (...data: any) => void;
  error: (...data: any) => void;
  toggleConsole: (value: boolean) => void;
}

const loggerInfo: ILoggerInfo = {
  debug: {
    levelCode: 1,
    color: 'teal'
  },
  error: {
    levelCode: 2,
    color: 'crimson'
  },
  info: {
    levelCode: 3,
    color: 'cornflowerblue'
  },
  warn: {
    levelCode: 4,
    color: 'darkorange'
  }
};

class Logger {
  disableConsole: boolean;

  consoleLevel: string;

  constructor(disable?: boolean) {
    this.disableConsole = disable || false;
  }

  public init() {
    const consoleLogger: IConsoleLogger = {
      debug: (...data: any) => this.log(LogLevel.DEBUG, ...data),
      error: (...data: any) => this.log(LogLevel.ERROR, ...data),
      info: (...data: any) => this.log(LogLevel.INFO, ...data),
      warn: (...data: any) => this.log(LogLevel.WARN, ...data),
      toggleConsole: (value: boolean) => this.toggleConsole(value)
    };

    return consoleLogger;
  }

  public toggleConsole(value: boolean) {
    this.disableConsole = value;
  }

  private consoleLoggerFn(level: LogLevel, ...data: any) {
    const style = `background-color: ${loggerInfo[level].color}; font-size:10px; color: white; padding: 1px 5px;`;
    window.console[level](`%c${level.toUpperCase()}`, style, ...data);
  }

  private log(level: LogLevel, ...data: any) {
    if (!this.disableConsole) {
      this.consoleLoggerFn(level, ...data);
    }
  }
}

function createLogger(config?: any) {
  const logger = new Logger(config);

  return logger.init();
}

const logger = createLogger();

export default logger;
